import { useCategories } from './useCategories';
import { CategoryData } from '../../data/materialsAndCategories';
import { Category } from '../../services/categories.service';

/**
 * Hook que retorna as categorias no formato CategoryData (compatível com o código existente)
 * Faz o mapeamento dos dados da API para o formato esperado
 */
export function useCategoriesData() {
  const { data: categories, isLoading, error, ...rest } = useCategories();

  // Mapeia os dados da API para o formato CategoryData
  const categoriesData: CategoryData[] = categories
    ? categories
        .map((cat: Category) => {
          // Tenta mapear os campos da API para CategoryData
          // Assumindo que a API retorna code, min_age_months, max_age_months
          // ou que esses campos podem estar em diferentes propriedades
          return {
            id: typeof cat.id === 'string' ? parseInt(cat.id, 10) : cat.id,
            code: cat.code || cat.name || String(cat.id),
            min_age_months: cat.min_age_months ?? 0,
            max_age_months: cat.max_age_months ?? 1000,
          };
        })
        .filter((cat): cat is CategoryData => {
          // Filtra apenas categorias válidas (com code)
          return !!cat.code;
        })
    : [];

  return {
    data: categoriesData,
    isLoading,
    error,
    ...rest,
  };
}

